import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import VueGtag from 'vue-gtag'

//Websockets
import Echo from 'laravel-echo';
import Api from "@/apis/Api";
import Pusher from "pusher-js";

Vue.config.productionTip = false

Vue.use(VueGtag, {
    config: {
        id: 'G-QSYEN2XEJ7',
        params: {
            send_page_view: false
        }
    }
}, router)

// use beforeEach route guard to set the language
router.beforeEach((to, from, next) => {

  // use the language from the routing param or default language
  let language = to.params.lang;
  if (!language) {
    language = 'en'
  }

  // set the current language for i18n.
  i18n.locale = language
  next()
})


  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_WEBSOCKET_KEY,
    cluster: process.env.VUE_APP_WEBSOCKET_CLUSTER,
    wsHost: process.env.VUE_APP_WEBSOCKET_HOST,
    wsPort: 6001,
    wssPort: 6001,
    forceTLS: true,
    authorizer: (channel, options) => {
      return {
        authorize: (socketId, callback) => {
          Api.post('broadcasting/auth', {
              socket_id: socketId,
              channel_name: channel.name
          })
          .then(response => {
              callback(false, response.data);
          })
          .catch(error => {
              callback(true, error);
          });
        }
      };
    },
  });
  
store.dispatch('auth/me').then(() => {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})